<template>
  <div class="hello">
     <div class="statistics containerize" v-if="selected !== 'home'">
      <h1>What is the price of food every city prefers?</h1>
      <h3>Purchasing parity distribution through dietary preferences</h3>
      <p>Inspired by <a href="https://www.investopedia.com/terms/b/burgernomics.asp" target="_blank">Burgernomics</a> this index is also a colloquial manner to measure the differences
        between this cities to acquire the same basic product.
        The final number is produced by counting the number of occurrence of a product and multiplying it with the fixed price from the <a href="https://www.numbeo.com" target="_blank">numbeo.com</a> database. For more information about this method
        is available <a href="https://www.economist.com/news/2018/07/11/the-big-mac-index" target="_blank">here (PPP)</a>. </p>
      <div class="graph">
        <div class="tac">
          <h1 class="total">
            <span class="tots">TOTAL:</span>
            {{formatPrice(allSum(obj[selected].food))}}€
          </h1>
        </div>
        <trend class="trend"
          :data="allSumArray(obj[selected].food)"
          :gradient="gradient"
          :max="2150"
          smooth >
        </trend>
        <ul>
          <li v-for="(v, key) in obj[selected].food" v-bind:key="key">
            <h4 :alt="v.qty"> <span class="big"> {{emojis[key]}}</span> <span class="share">{{v.share}}</span >
            <span class="price">{{formatPrice(v.share * v.price)}}€</span></h4>
            <sub>({{v.price}}€ x {{v.qty}})</sub>
          </li>
        </ul>
      </div>
    </div>
    <div class="words" v-if="selected !== 'home'">
      <div class="containerize">
        <h1>Most used emojis in {{obj[selected].name}}</h1>
        <br><br>
        <ul class="listemojis">
          <li class="repetition" v-for="(item, index) in obj[selected].top_emojis" :key="index">
            <ul>
              <b>{{item}}</b>
              <li v-for="which in item" :key="which">{{index}}</li>
            </ul>
          </li>
        </ul>
        * <b>{{obj[selected].emojis}}</b>
        total emojis found in <b>{{obj[selected].text}}</b> characters of text<br>
        * Percentage of emojis =
        <b>{{((obj[selected].emojis / obj[selected].text) * 100).toFixed(2)}} %</b>
     </div>
     <br><br>
    </div>
    <div class="mapping"  v-if="selected !== 'home'">
      <div class="containerize">
        <h1>Where images have been shared this month?</h1>
        <p>Images shared on Twitter with popular foodie tags during the last 30 days.</p>
      </div>
      <div id="map"></div>
      <ul class="images">
        <li v-for="m in data" v-bind:key="m.id">
          <a :href="m.id" v-on:click.prevent="getImage(m.id)"><img :src="m.properties.image" :alt="m.properties.title"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import mapboxgl from 'mapbox-gl'

export default {
  name: 'HelloWorld',
  props: {
    obj: Object,
    selected: String
  },
  data () {
    return {
      disclaimer: {
        text: 'These data are based on 2210 entries in the past 18 months from 257 different contributors',
        update: 'October 2018'
      },
      gradient: ['#0E6F96'],
      emojis: {
        bread: '🍞',
        eggs: '🥚',
        chicken: '🍗',
        beef: '🥩',
        rice: '🍚',
        beer: '🍺',
        banana: '🍌',
        potato: '🥔',
        tomato: '🍅',
        cappuccino: '☕'
      },
      token: process.env.VUE_APP_TOKEN,
      data: [],
      allofthem: []
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    '$route': ['loadData']
  },
  methods: {
    getImage: function (id) {
      const vm = this
      this.data.forEach(element => {
        if (element.id === id) {
          let popUps = document.getElementsByClassName('popupclass');
          // Check if there is already a popup on the map and if so, remove it
          if (popUps[0]) popUps[0].remove();
          this.flyToStore(element)
          // add pop up
          new mapboxgl.Popup({ offset: 25, className: 'popupclass'})
          .setLngLat(element.geometry.coordinates)
          .setHTML(`<h3> ${vm.formatDate(element.properties.created_at)} </h3>
          <img src="${element.properties.image}" />
          <p> ${element.properties.text} </p>
          <a href="${element.properties.expanded_url}" target="_blank" class="gotoit">see it in twitter</a>`)
          .addTo(vm.map)
        }
      })
    },
    flyToStore: function (currentFeature) {
      this.map.flyTo({
        center: [currentFeature.geometry.coordinates[0], currentFeature.geometry.coordinates[1] - 0.01],
        zoom: 13
      })
    },
    allSum: function (food) {
      let total = 0
      Object.keys(food).forEach(function (key) {
        total = total + food[key].price * food[key].share
      })
      return total
    },
    formatDate: function (date) {
      const datum = new Date(Date.parse(date))
      const monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
      ]
      const day = datum.getDate()
      const monthIndex = datum.getMonth()
      const year = datum.getFullYear()

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    },
    allSumArray: function (food) {
      let total = []
      Object.keys(food).forEach(function (key) {
        // console.log(key, food[key])
        total.push(parseFloat((food[key].price * food[key].share).toFixed(2), 10))
      })
      return total
    },
    sorted: function (numbers) {
      return Object.entries(numbers).sort().reduce((obj, [k, v]) => ({
        ...obj,
        [k]: v
      }), {})
    },
    loadData: async function () {
      var vm = this
      // need to reset data
      vm.data = []
      try {
        // console.info(this.selected, this.selected === 'home')
        let callobj = ''
        if (this.selected === 'home') {
          callobj = `${process.env.VUE_APP_URL}everywhere/foodie,foodies,foodporn,instafood,yum,food,foodpics,yummyfood,geilesessen/`
        } else {
          callobj = `${process.env.VUE_APP_URL}thirty_days/foodie,foodies,foodporn,instafood,yum,food,foodpics,yummyfood,geilesessen/${this.obj[this.selected].coord.lng} ${this.obj[this.selected].coord.lat} ${this.obj[this.selected].distance}`
        }
        const response = await axios.get(callobj)
        if (response.status === 200) {
          // console.log(response.status, response.data.length) // eslint-disable-line no-console
          for (let i = 0; i < response.data.length; i++) {
            let point = {}
            if (response.data[i].coordinates != null) {
              // console.log(response.data[i].coordinates.coordinates)
              point = {
                'id': i,
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': response.data[i].coordinates.coordinates
                },
                'properties': {
                  'title': response.data[i].user.name,
                  'text': response.data[i].text,
                  'created_at': response.data[i].created_at,
                  'image': response.data[i].extended_tweet ? response.data[i].extended_tweet.entities.media[0].media_url : response.data[i].entities.media[0].media_url,
                  'expanded_url': response.data[i].extended_tweet ? response.data[i].extended_tweet.entities.media[0].expanded_url : response.data[i].entities.media[0].expanded_url
                }
              }
            } else if (response.data[i].place != null) {
              point = {
                'id': i,
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': response.data[i].place.bounding_box.coordinates[0][1]
                },
                'properties': {
                  'title': response.data[i].user.name,
                  'text': response.data[i].text,
                  'created_at': response.data[i].created_at,
                  'image': response.data[i].extended_tweet ? response.data[i].extended_tweet.entities.media[0].media_url : response.data[i].entities.media[0].media_url,
                  'expanded_url': response.data[i].extended_tweet ? response.data[i].extended_tweet.entities.media[0].expanded_url : response.data[i].entities.media[0].expanded_url
                }
              }
            } else {
              point = {}
            }
            vm.data.push(point)
          }
          if (this.selected !== 'home') {
            // console.log('this.selected', this.selected, 'creating map')
            this.createMap()
          }
        }
      } catch (error) {
        console.error('error', error)  // eslint-disable-line no-console
      }
    },
    formatPrice: function formatPrice (value) {
      let val = (value / 1).toFixed(1).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    createMap: function () {
      // console.log('createMap - data', data)
      var vm = this
      const ctr = vm.obj[vm.selected] !== 'home' ? [vm.obj[vm.selected].coord.lng, vm.obj[vm.selected].coord.lat] : [4.000, -72.00]
      const zm = vm.selected !== 'home' ? 9 : 3
      mapboxgl.accessToken = this.token
      // init the map
      this.map = new mapboxgl.Map({
        style: 'mapbox://styles/mapbox/light-v9',
        scrollZoom: {
          ctrl: true
        },
        center: ctr,
        zoom: zm,
        container: 'map'
      }).on('load', function () {
        this.addLayer({
          'id': 'chicuca',
          'type': 'symbol',
          'source': {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': vm.data
            }
          },
          'layout': {
            'icon-image': '{icon}-15',
            'text-field': '{title}',
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-size': 14,
            'text-offset': [0, 0.2],
            'text-anchor': 'top'
          }
        })
      })
      vm.allofthem = []
      vm.map.addControl(new mapboxgl.NavigationControl())
      vm.map.scrollZoom.disable()
      vm.data.forEach(function (marker) {
        // create a HTML element for each feature
        var el = document.createElement('div')
        el.setAttribute("id", marker.id);
        el.className = 'marker'
        // make a marker for each feature and add to the map
        var x = (Math.random(-1, 1) / 100)
        x *= Math.floor(Math.random() * 2) === 1 ? 1 : -1
        var y = (Math.random(-1, 1) / 100)
        y *= Math.floor(Math.random() * 2) === 1 ? 1 : -1
        marker.geometry.coordinates[0] = marker.geometry.coordinates[0] - x
        marker.geometry.coordinates[1] = marker.geometry.coordinates[1] - y
        vm.allofthem.push(marker.geometry.coordinates)
        // console.log(dateToString(myDate)) // 1995-12-04
        // console.log(allofthem)
        new mapboxgl.Marker(el)
          .setLngLat(marker.geometry.coordinates)
          .setPopup(
            new mapboxgl.Popup({ offset: 25, className: 'popupclass' })
              .setHTML(`<h3> ${vm.formatDate(marker.properties.created_at)} </h3><img src="${marker.properties.image}" /><p> ${marker.properties.text} </p><a href="${marker.properties.expanded_url}" target="_blank" class="gotoit">see it in twitter</a>`)
          ) // add popups
          .addTo(vm.map)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$mapbg:  rgb(202, 210, 211);
$green: #42b983;
$blue: #0E6F96;
$dark: #2c3e50;

.marker {
  background: rgba($dark, 0.2);
  background-size: cover;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
}

.gotoit{
  color: #fff;
  background:$blue;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  &[target='_blank']::after {
    display: none;
  }
}

.mapboxgl-popup {
  max-width: 300px;
}

.mapboxgl-popup-content {
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  width: 100%;
  img{
    width: 100%;
  }
}

.images{
  margin: 0;
  padding: 0;
  list-style-type: none;
  background: $dark;
  li{
    display: inline-block;
    vertical-align: text-top;
    max-height: 100px;
    max-width: 100px;
    overflow: hidden;
    img{
      max-height: 100px;
    }
  }
}

.words{
  background:$mapbg;
  h1{
    margin-top: 50px;
  }
  ul.listemojis{
    margin: 0 auto;
    text-align: center;
    list-style-type: none;
    li{
      padding: 0;
      margin: 0;
      display: block;
      font-size: 35px;
      text-align: left;
      margin-bottom: 30px;
      position: relative;
      b {
        margin-top: 0;
        margin-right: 5px;
        font-size: 17px;
        position: relative;
        top: -7px;
        display: inline-block;
        color: #2c3e50;
        border-radius: 100%;
        height: 40px;
        width: 40px;
        line-height: 40px;
        text-align: center;
        border:2px solid #f4f4f2;
        background: #f4f4f2;
      }
      ul{
        li{
          color: transparent;
          text-shadow: 0 0 0 #f4f4f2;
          display: inline-block;
          margin: 0;
          padding: 0;
          letter-spacing: -5px;
          &:nth-last-child(1){
            color: white;
            text-shadow:0 0 0 none;
            margin-left: 2px;
          }
        }
      }
    }
  }
}

.statistics{
  position: relative;
  min-height: 200px;
  padding-top: 80px;
  @media screen and (min-width: 767px) {
      padding-top: 60px;
  }
  .graph{
    position: relative;
    margin: 40px 0;
    h3{
    }
  }
  ul{
    list-style-type: none;
    margin: 0 auto;
    text-align: center;
    li{
      display: inline-block;
      h4{
        margin: 0;
        position: relative;
      }
    }
  }
}

.share{
  position: absolute;
  top: -10px;
  left: 30px;
  background: #fff;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 100%;
  color: #2c3e50;
  // border: 1px solid $mapbg;
  font-size: 12px;
}

.price{
  position: relative;
  width: 80px;
  display: inline-block;
  text-align: left;
  padding-left: 5px;
}


.big{
  font-size: 45px;
}

$hb: 180px;
.total{
  position: absolute;
  background: #0E6F96;
  text-align: center;
  margin: 0 auto;
  display: inline-block;
  border: 4px solid #0E6F96;
  width: $hb;
  height: $hb;
  line-height: $hb;
  border-radius: 100%;
  top: 10px;
  margin-left: -100px;
  color: #fff;
  // border: 4px solid #fff;
   @media screen and (max-width: 600px) {
    display: block;
    position: relative;
    top: 0;
    margin: 0 auto;
    margin-bottom: 50px;
  }
  span.tots {
    position: absolute;
    top:-35px;
    left: 50px;
    font-size: 20px;
    color: #fff;
  }
}
</style>